import Swiper from 'swiper'
import { Scrollbar, Pagination, Autoplay } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/scrollbar'
import 'swiper/css/pagination'

export default (type = 'default', options = {}) => {
  const { bullets = false, autoplay = false } = options

  return {
    type: type,
    showPrev: false,
    showNext: true,
    swiper: null,
    isMobileOnly: type === 'mobile-only',

    init() {
      const modules = bullets ? [Pagination] : [Scrollbar]
      if (autoplay) modules.push(Autoplay)

      // Use container ref if available (for pagination outside swiper), otherwise use swiper ref
      const containerEl = this.$refs.container || this.$refs.swiper

      const baseConfig = {
        modules,
        grabCursor: true,
        slidesPerView: 'auto',
        spaceBetween: 24,
        ...(bullets
          ? {
              pagination: {
                el: containerEl.querySelector('.swiper-pagination'),
                clickable: true,
              },
            }
          : {
              scrollbar: {
                el: containerEl.querySelector('.swiper-scrollbar'),
                draggable: true,
                hide: false,
              },
            }),
        ...(autoplay && {
          autoplay: {
            delay: 5000,
            disableOnInteraction: true,
          },
        }),
        on: {
          activeIndexChange: () => {
            this.setPaginationVisibility()
          },
        },
      }

      if (this.isMobileOnly) {
        // Mobile-only slider: enabled on mobile, disabled on tablet+
        this.swiper = new Swiper(this.$refs.swiper, {
          ...baseConfig,
          slidesPerView: 1,
          spaceBetween: 16,
          enabled: true,
          breakpoints: {
            600: {
              slidesPerView: 2,
            },
            1024: {
              enabled: false,
            },
          },
        })
      } else {
        this.swiper = new Swiper(this.$refs.swiper, {
          ...baseConfig,
          breakpoints: {
            724: { slidesPerView: type === 'full' ? 1 : 2 },
            1024: { slidesPerView: type === 'full' ? 1 : 3 },
          },
        })
      }

      this.setPaginationVisibility()
    },
    setPaginationVisibility() {
      if (!this.swiper) return
      this.showPrev = !this.swiper.isBeginning
      this.showNext = !this.swiper.isEnd
    },
    next() {
      this.swiper?.slideNext()
    },
    prev() {
      this.swiper?.slidePrev()
    },
    destroy() {
      this.swiper?.destroy()
    },
  }
}
